import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import AnimatedBackground from '../AnimatedBackground/AnimatedBackground';
import './Technologies.css';

const Technologies = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const allTechnologies = [
    'Siemens PLC', 'Allen-Bradley', 'Schneider Electric', 'Mitsubishi', 'ABB', 'Omron',
    'WinCC', 'FactoryTalk', 'Ignition', 'Wonderware', 'Citect', 'Iconics',
    'KUKA', 'Fanuc', 'ABB Robotics', 'Universal Robots', 'Yaskawa', 'Kawasaki',
    'Cognex', 'Keyence', 'Basler', 'OpenCV', 'Halcon', 'LabVIEW Vision',
    'AWS IoT', 'Azure IoT', 'ThingWorx', 'MQTT', 'Node-RED', 'Edge Computing',
    'TensorFlow', 'PyTorch', 'Power BI', 'Tableau', 'Python', 'R',
    'Servo Systems', 'Stepper Motors', 'VFDs', 'Motion Controllers', 'CNC', 'CAM',
    'OPC UA', 'Modbus', 'Profinet', 'EtherCAT', 'DeviceNet', 'CANopen',
    'Indoor Positioning System', 'Smart Automation', 'Process Control', 'Analytics',
    'Data Acquisition', 'MES Systems', 'Custom Enterprise Applications', 'SCADA',
    'Predictive Maintenance', 'Remote Monitoring', 'Alert Systems', 'Machine Learning',
    'Computer Vision', 'Industrial IoT', 'Cloud Computing', 'Big Data',
    'Real-Time Monitoring', 'Asset Management', 'Quality Control', 'Traceability',
    'Batch Management', 'Recipe Management', 'Alarm Management', 'Historian',
    'SQL Server', 'MySQL', 'PostgreSQL', 'MongoDB', 'InfluxDB', 'TimescaleDB',
    'React', 'Node.js', 'Angular', '.NET', 'C#', 'Java',
    'Docker', 'Kubernetes', 'Microservices', 'REST APIs', 'GraphQL', 'WebSockets',
    'RFID', 'Barcode Scanners', 'NFC', 'GPS Tracking', 'BLE Beacons', 'UWB',
    'Safety PLCs', 'Safety Relays', 'Light Curtains', 'Emergency Stop', 'Risk Assessment',
    'Energy Monitoring', 'Power Meters', 'Building Automation', 'HVAC Control',
    'Vibration Analysis', 'Thermal Imaging', 'Acoustic Monitoring', 'Leak Detection',
    '3D Printing', 'Additive Manufacturing', 'Material Handling', 'AGV Systems'
  ];

  // Split technologies into 5 rows
  const rowCount = 5;
  const itemsPerRow = Math.ceil(allTechnologies.length / rowCount);
  const rows = Array.from({ length: rowCount }, (_, i) => 
    allTechnologies.slice(i * itemsPerRow, (i + 1) * itemsPerRow)
  );

  return (
    <section id="technologies" className="technologies" ref={ref}>
      <AnimatedBackground variant="tech" />
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title">Technology Stack</h2>
          <p className="section-subtitle">
            Leveraging industry-leading platforms and cutting-edge technologies
          </p>
        </motion.div>

        <motion.div
          className="tech-container"
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {rows.map((row, rowIndex) => (
            <div key={rowIndex} className={`tech-row tech-row-${rowIndex % 2 === 0 ? 'ltr' : 'rtl'}`}>
              <div className="tech-tags-all">
                {[...row, ...row, ...row].map((tech, index) => (
                  <span
                    key={`${rowIndex}-${index}`}
                    className="tech-tag"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div
          className="tech-cta"
          style={{
            backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)), url(${process.env.PUBLIC_URL}/images/BG_Handshake.png)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <h3>Need a Custom Technology Solution?</h3>
          <p>We integrate with virtually any industrial platform and can develop custom solutions tailored to your unique requirements.</p>
          <button className="btn-primary" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>Discuss Your Requirements</button>
        </motion.div>
      </div>
    </section>
  );
};

export default Technologies;
